import ArchivedContainer from "./ArchivedContainer";

export default ArchivedContainer;